import type { ElementType, ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/cn';

interface ContainerProps<T extends ElementType> {
  as?: T;
  className?: string;
}

/** Page gutter + max width. One place to tune horizontal rhythm. */
export function Container<T extends ElementType = 'div'>({
  as,
  className,
  ...props
}: ContainerProps<T> & Omit<ComponentPropsWithoutRef<T>, keyof ContainerProps<T>>) {
  const Comp = (as ?? 'div') as ElementType;
  return <Comp className={cn('mx-auto w-full max-w-5xl px-6 sm:px-8', className)} {...props} />;
}
